import { createSlice } from "@reduxjs/toolkit";

export const myCoursesSlice = createSlice({
  name: "myCourses",
  initialState: { myCourses: null },
  reducers: {
    setMyCourses: (state, action) => {
      state.value = action.payload;
    },
    clearMyCourses: (state) => {
      state.value = null;
    },
  },
});

export const { setMyCourses, clearMyCourses } = myCoursesSlice.actions;

export const selectMyCourses = (state) => state.myCourses.value;

export default myCoursesSlice.reducer;
